import { faCampground } from "@fortawesome/free-solid-svg-icons";
import { faGraduationCap } from "@fortawesome/free-solid-svg-icons";
import { faCode } from "@fortawesome/free-solid-svg-icons";
import { faFutbol } from "@fortawesome/free-solid-svg-icons";
import { faSwimmer } from "@fortawesome/free-solid-svg-icons";
import { faAward } from "@fortawesome/free-solid-svg-icons";
import { faRunning } from "@fortawesome/free-solid-svg-icons";

export const miscData = [
	{
		organization: "Courses",
		icon: faGraduationCap,
		courses: [
			{
				title: "Ethereum and Solidity: The Complete Developer's Guide",
				organization: "Udemy",
				year: "2022",
				icon: "",
			},
			{
				title: "JavaScript Algorithms and Data Structures Masterclass",
				organization: "Udemy",
				year: "2022",
				desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
				icon: "",
			},
			{
				title: "Blockchain Essentials: An Introduction to Blockchain",
				organization: "ConsenSys Academy",
				year: "2021",
				desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
				icon: "",
			},
		],
	},
	{
		title: "Ironman Madison Finisher",
		organization: "Ironman Foundation",
		year: "2021",
		desc: "Raised $3,500 for the Ironman Foundation and completed the course with a time of 15:22:01.",
		icon: faRunning,
	},
	{
		title: "Full-Stack Engineering Bootcamp Grad",
		organization: "Flatiron School",
		year: "2021",
		desc: "At Flatiron, I completed 5 full-stack engineering modules learning HTML, CSS, Ruby, Ruby on Rails, JavaScript, and React.",
		icon: faCode,
	},
	{
		title: "Men's Team Captain",
		organization: "Grinnell College Soccer",
		year: "2014",
		desc: "My Senior year, 20+ teammates elected me as captain where I functioned as a liaison between the team and coaching staff.",
		icon: faFutbol,
	},
	{
		title: "Academic All-Conference Player",
		organization: "Grinnell College Soccer",
		year: "2014",
		desc: "My Senior year, I was awared Academic All-Conference for maintaining a certain GPA while involved in a varisty sport.",
		icon: faAward,
	},
	{
		title: "Men's 400-Freestyle Record Holder",
		organization: "Grinnell College Swimming",
		year: "2013",
		desc: "My Junior year, I was the first leg of the 400 yard freestyle relay that set a new school record with a time of 3:06.74.",
		icon: faSwimmer,
	},
	{
		title: "Eagle Scout",
		organization: "Boy Scouts of America",
		year: "2008",
		desc: "Over the course of 10+ years, I earned over 25 merit badges, acted in various leadership roles, and completed an Eagle Service Project, ultimately achieving the rank of Eagle.",
		icon: faCampground,
	},
];

// skill learning
// volunteer work
// active member
